import React from 'react';
import { SummarySVG } from '../../../components';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function Summariesheader () {
    const { t } = useTranslation();
    return (
        <Box
            display='flex'
            alignItems='center'

            style={{ height: '58px' }}>
            <Box className='svgIcon'>
                {<SummarySVG customStroke='#F95623' />}

            </Box>
            <Typography variant='pageHeaderTitle' className='headerText'>{t('summary.title')}</Typography>
        </Box>
    );
}
